module.exports = __webpack_public_path__ + "static/fipclovetwirlbearmain-79638922b8e88d1eb280ce76b279abf8.jpeg";